import aMathefant from '../game-05-mathefant/assets/Mathefant.png'

const url =
  'https://wdradaptiv-vh.akamaihd.net/i/medp/ondemand/weltweit/fsk0/215/2157520/,2157520_26882787,2157520_26882782,2157520_26882784,2157520_26882783,2157520_26882786,2157520_26882785,.mp4.csmil/master.m3u8'

export default {
  id: '13',
  name: 'Mathefant (8/10)',
  subtitle: 'Code ein 1x1-Spiel',
  image: aMathefant,
  video: url,
}
